import { Link } from "react-router-dom";
import { ArrowLeft, Construction, Sparkles } from "lucide-react";
import AppShell from "@/components/app/AppShell";

export default function ComingSoon({ name, description }) {
  return (
    <AppShell>
      <div className="min-h-[calc(100vh-84px)] px-6 py-12 sm:px-10 flex items-center justify-center">
        <section className="hm-card max-w-2xl w-full rounded-md border border-white/10 p-8 sm:p-12 text-center">
          <div className="mx-auto mb-6 inline-flex h-14 w-14 items-center justify-center rounded-full border border-[#F59E0B]/30 bg-[#F59E0B]/10 text-[#F59E0B]">
            <Construction className="h-6 w-6" strokeWidth={1.5} />
          </div>
          <div className="overline mb-3 inline-flex items-center gap-2"><Sparkles className="h-3 w-3" /> Coming soon</div>
          <h1 className="font-serif-editorial text-4xl sm:text-5xl tracking-tight">{name}</h1>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-[#A1A1AA]">{description}</p>
          <Link to="/dashboard" className="hm-btn-ghost mt-8 inline-flex items-center gap-2 rounded-md px-4 py-2 text-xs">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to dashboard
          </Link>
        </section>
      </div>
    </AppShell>
  );
}
